const setHeightForWidget = (event, document) => {
    const fdpqIframeElement = document.getElementById('fdpq-iframe');

    if (fdpqIframeElement !== null
    && event.data
    && event.data.type === 'onFdpqWidgetHeightChanged'
    && event.data.height != null) {
        const height = Number(event.data.height);
        fdpqIframeElement.height = height + 'px';
        fdpqIframeElement.style.marginBottom = height > 0 ? '20px' : '0';
    }
};

export default setHeightForWidget;
